import { render, staticRenderFns } from "./CreatePopularItemDialog.vue?vue&type=template&id=d1724e34&scoped=true&"
import script from "./CreatePopularItemDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePopularItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatePopularItemDialog.vue?vue&type=style&index=0&id=d1724e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1724e34",
  null
  
)

export default component.exports